import { ActionTypes } from '../constants';

export const getUserPermissions = () => ({
    type: ActionTypes.permissions.getUserPermissions
});

export const getUserPermissionsSuccess = (data) => ({
    type: ActionTypes.permissions.getUserPermissionsSuccess,
    payload: data
});

export const getUserPermissionsFail = (error) => ({
    type: ActionTypes.permissions.getUserPermissionsFail,
    payload: error
});

export const updateUserPermissions = () => ({
    type: ActionTypes.permissions.updateUserPermissions
});

export const updateUserPermissionsSuccess = (data) => ({
    type: ActionTypes.permissions.updateUserPermissionsSuccess,
    payload: data
});

export const updateUserPermissionsFail = (error) => ({
    type: ActionTypes.permissions.updateUserPermissionsFail,
    payload: error
});

export const listActivityPermissions = () => ({
    type: ActionTypes.permissions.listActivityPermissions
});

export const listActivityPermissionsSuccess = (data) => ({
    type: ActionTypes.permissions.listActivityPermissionsSuccess,
    payload: data
});

export const listActivityPermissionsFail = (error) => ({
    type: ActionTypes.permissions.listActivityPermissionsFail,
    payload: error
});

export const updateActivityPermissions = () => ({
    type: ActionTypes.permissions.updateActivityPermissions
});

export const updateActivityPermissionsSuccess = (data) => ({
    type: ActionTypes.permissions.updateActivityPermissionsSuccess,
    payload: data
});

export const updateActivityPermissionsFail = (error) => ({
    type: ActionTypes.permissions.updateActivityPermissionsFail,
    payload: error
});

export const updateUser2FA = () => ({
    type: ActionTypes.permissions.updateUser2FA
});

export const updateUser2FASuccess = (data) => ({
    type: ActionTypes.permissions.updateUser2FASuccess,
    payload: data
});

export const updateUser2FAFail = (error) => ({
    type: ActionTypes.permissions.updateUser2FAFail,
    payload: error
});

export const updateUserPermissionsViaSocket = (data) => ({
    type: ActionTypes.permissions.updateUserPermissionsViaSocket,
    payload: data
});
